module.exports = __webpack_public_path__ + "img/zhuanye-fenzu.3714206f.svg";